<template>
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters, mapState } from "vuex";

export default defineComponent({
  props: [],
  computed: {
    ...mapState(["idleVue"]),
    ...mapGetters("oidcStore", ["oidcIsAuthenticated"]),
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || "Applicant Portal";
      },
    },
  },
});
</script>

<style lang="scss">
@import "../src/styles/fonts.css";
@import "../src/styles/site.css";
@import "../src/styles/custom.css";
@import "../src/styles/theme.css";
@import "@uppy/core/dist/style.css";
@import "@uppy/dashboard/dist/style.css";

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #075733;
}

.cuscd-page-wrap {
  display: block;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%;
}

.cuscd-display-none {
  display: none;
}

/* RESET */
.cuscd-full-wrap *,
.cuscd-full-wrap *::before,
.cuscd-full-wrap *::after {
  box-sizing: border-box;
}
body.cuscd-full-wrap {
  background-color: #eeeeee;
  display: block;
 	font-family: "Montserrat", Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  padding: 0;
  position: relative;
}

body.cuscd-full-wrap:has(.cuscd-full-wrap-white) {
  background-color: #fff;
}

.cuscd-page-wrap {
  display: block;
  margin: 0;
  /* overflow: hidden; */
  padding: 0;
  position: relative;
  width: 100%;
}
.cuscd-full-wrap a {
  color: #383838;
  text-decoration: none;
}
.cuscd-full-wrap a:hover,
.cuscd-full-wrap a:focus {
  text-decoration: none;
  filter: brightness(90%);
}
.cuscd-full-wrap .cuscd-wrap a.nav-link {
  color: #ffffff;
}
.cuscd-sr-only {
  clip: rect(0, 0, 0, 0);
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.cuscd-section-divide {
  padding: 1.8rem 2.25rem;
  border-bottom: 1px solid #e2e2e2;
}
.cuscd-section-divide:last-child {
  border-bottom: 0;
}
.cents {
  font-size: 0.65em;
}
</style>
